import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class OtpSerializer extends BaseSerializer {
  deserialize(raw) {
    const serverRes = raw?.data || raw?.error;
    const success = serverRes?.statusCode == 200;
    if (!success) {
      return {
        statusCode: serverRes?.statusCode || raw?.status || 500,
        success: false,
        message:
          (serverRes.message || "Erreur lors de d'envoie d'otp") +
          ` Code d'erreur: OTP_ERR_${
            serverRes.statusCode || raw.status || '1000'
          }`,
        data: null
      };
    }
    return {
      statusCode: 200,
      success: true,
      message: 'Otp sent',
      data: {
        otp: serverRes.data?.otp,
        token: serverRes.data?.token,
        exp: serverRes.data?.exp
      }
    };
  }

  serialize(data) {
    if (!data) return null;

    let phoneNumber = data.phoneNumber;
    if (data.prefix == `229`) phoneNumber = phoneNumber.replace(/^01/, '');
    return {
      email: data.email,
      channel: data.channel,
      prefix: data.prefix,
      whatsappPhoneNumber: phoneNumber,
      subject: 'Otp de vérification Exourf',
      number: true,
      timestamp: Date.now(),
      service: 'sumremit',
      name: data.name || 'Utilisateur'
    };
  }
}

export const otpSerializer = new OtpSerializer();
